module.exports = __webpack_public_path__ + "media/images/dingdong-allcare-b8adf4da7a2c27d3f0227553f5cad46a.png";